<template>
    <div id="ssoSpinner">
    </div>
</template>
<script>
    import apis from '../common/network'
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import logger from '../common/logger'
    import authToken from '../common/authToken'
    import rules from '../common/permissions'
    import checkUIPermissions from '../common/UIPermissions'
    import Vue from 'vue';
    import Cookies from 'js-cookie'

    export default {
        beforeMount() {
            //Change by Haris, ssotoken is now i url, cookie
            //var token = this.$route.query.ssoauthtoken || '';
            //var token = Cookies.get('SsoToken') || '';
            //var url = this.$route.query.url || '/home';
            //if (token.length) {
            //    apis.unprotectedApi.post(
            //        "auth",
            //        {
            //            Token: token
            //        }
            //    ).then((r) => r.data).then((resp) => {
            //        authToken.set(resp.token || resp.Token);
            //        rules.getPermissions(resp.token || resp.Token);
            //        this.$store.commit('setIsLoggedIn', true);
            //        checkUIPermissions();
            //        if (url)
            //            this.$router.replace(url);
            //    }).catch((err) => {
            //        console.log(err)
            //        logger.log(err);
            //        apis.navigateToLogin();
            //    });
            //} else {
            //    apis.navigateToLogin();
            //}

           //AZURE AD
           apis.navigateToLogin("/home");
        },
        mounted() {
            createSpinner({
                target: document.getElementById('ssoSpinner')
            });
            showSpinner(document.getElementById('ssoSpinner'));
        }
    };

</script>
